import React, { useEffect } from 'react'
import { NextPage } from 'next'
import { useLojinhaContext } from '@lojinha/context'
import { Spinner } from '@lojinha/design-system'
import { useLogin } from '@lojinha/login'
import { usePrefetch } from '../../../router'
import { MainLayout } from '../../modules/app/main-layout'
import { Profile } from '../../modules/profile'

const ProfilePage: NextPage = () => {
  usePrefetch('/identification')

  const { isContextLoaded, isAuthenticated } = useLojinhaContext()

  const { redirectToLogin } = useLogin()

  useEffect(() => {
    if (!isAuthenticated) redirectToLogin('/meu/perfil')
  }, [isAuthenticated, redirectToLogin])

  if (!isAuthenticated && isContextLoaded) return <Spinner />

  if (isContextLoaded) {
    return (
      <MainLayout hasMarginBottom>
        <Profile />
      </MainLayout>
    )
  }

  return null
}

export default ProfilePage
